import { useMutation } from "@apollo/client";
import {
  Button,
  CircularProgress,
  InputAdornment,
  TextField,
} from "@mui/material";
import Drawer from "@mui/material/Drawer";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { RETRACT_CATERCASH } from "../../Graphql/mutations";
import { authVar, toggleSnackbar } from "../../ReactiveVariables";
import { formatter } from "../Common/commonUtils";
import { getRetractionAmountError } from "./cater-cash.utils";

export default function RetractCaterCash({
  customerId,
  open,
  outstanding,
  setOpen,
}) {
  const navigate = useNavigate();
  const [amount, setAmount] = useState("");
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [retractCaterCash, { loading }] = useMutation(RETRACT_CATERCASH, {
    refetchQueries: ["ListCaterCash", "ListCaterCashTotal"],
    awaitRefetchQueries: true,
  });

  function closeDrawer() {
    setOpen(false);
    setAmount("");
    setMessage("");
    setErrorMessage(null);
  }

  async function submitRetraction() {
    const validationError = getRetractionAmountError(amount, outstanding);
    if (validationError) {
      setErrorMessage(validationError);
      return;
    }

    try {
      await retractCaterCash({
        variables: {
          customerId,
          amount: Number(amount),
          message: message.trim() || null,
        },
      });
      toggleSnackbar({
        status: true,
        message: "CaterCash retracted successfully",
        variant: "success",
      });
      closeDrawer();
    } catch (error) {
      if (error?.message === "Not authenticated") {
        localStorage.clear();
        authVar({ loaded: true, auth: false });
        navigate("/admin", { state: "noAuth" });
        return;
      }
      toggleSnackbar({
        status: true,
        message: error?.message || "Unable to retract CaterCash",
        variant: "error",
      });
    }
  }

  return (
    <Drawer
      className="common-drawer"
      anchor="right"
      open={open}
      onClose={closeDrawer}>
      <div className="drawer-head">
        <h4 className="h4">Pull Back CaterCash</h4>
        <span style={{ cursor: "pointer" }} onClick={closeDrawer}>
          <img
            src="../assets/images/x-icon.svg"
            className="img-fluid"
            alt="close icon"
          />
        </span>
      </div>
      <div className="create-step-form">
        <p>
          Outstanding balance: <strong>{formatter.format(outstanding)}</strong>
        </p>
        <div className="textBox">
          <TextField
            autoFocus
            label="CATERCASH*"
            variant="outlined"
            className="textField allFeild"
            type="number"
            value={amount}
            onChange={(event) => {
              setAmount(event.target.value);
              setErrorMessage(null);
            }}
            inputProps={{ min: 0.01, max: outstanding, step: 0.01 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
          {errorMessage && (
            <span className="error-msg">{errorMessage}</span>
          )}
        </div>
        <div className="textBox">
          <TextField
            label="REASON (OPTIONAL)"
            variant="outlined"
            className="textField allFeild"
            multiline
            minRows={3}
            value={message}
            onChange={(event) => setMessage(event.target.value)}
          />
        </div>
      </div>
      <div className="createStepBtn">
        <Button
          className="cancelBtn"
          variant="contained"
          color="secondary"
          onClick={closeDrawer}>
          Cancel
        </Button>
        <Button
          className="saveBtn"
          variant="contained"
          color="primary"
          disabled={loading || outstanding <= 0}
          onClick={submitRetraction}>
          {loading ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            "Pull Back"
          )}
        </Button>
      </div>
    </Drawer>
  );
}
